




































































































import {Vue, Component, PropSync} from 'vue-property-decorator';
import proxySettingsForm from "@/pages/Pages/Push/proxySettingsForm.vue";
import {dp2Type} from "@/store/push/application/types";
import {isEmpty} from "lodash";

@Component({
  components: {proxySettingsForm}
})
export default class Dp2Settings extends Vue {
  @PropSync('dp2Options') dp2!: dp2Type;

  get isDP2Proxy(): boolean {
    return !isEmpty(this.dp2.proxy_settings);
  }

  set isDP2Proxy(value: boolean) {
    if (value) {
      this.$set(this.dp2, 'proxy_settings', { host: null });
    } else {
      this.$delete(this.dp2, 'proxy_settings');
    }
  }
}
